import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './DocActionButton.module.css';
import { cx } from '../../lib/cx';

export interface DocActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Ikonka / krátký label (např. „📍 Mapa", „📇 Adresář"). */
  children: ReactNode;
  /** Volitelně: variant (default = ghost yellow). */
  variant?: 'ghost' | 'solid';
}

/**
 * Drobné akční tlačítko pro `actions=` slot DocRow / DocBlock.
 * Ladí s dokumentovou paletou (žlutá akcentová), kompaktní výška ~24 px.
 */
export function DocActionButton({
  children,
  variant = 'ghost',
  className,
  type = 'button',
  ...rest
}: DocActionButtonProps) {
  return (
    <button
      type={type}
      className={cx(styles.btn, variant === 'solid' && styles.solid, className)}
      {...rest}
    >
      {children}
    </button>
  );
}
